import React from "react";
import { styled } from "styled-components";
import { colors } from "../../styles/theme";
import { Button } from "../../styles";
import { HiOutlineArrowUpRight } from "react-icons/hi2";
import { scrollIntoViewWithOffset } from "../../services/scroll.service";

const LocationSection = () => {
  return (
    <SectionContainer id="location">
      <ContentColumn>
        <SectionTag data-aos="fade-up">Visit our office</SectionTag>
        <SectionHeading data-aos="fade-up" data-aos-delay="80">
          Bakatue Street workspace
        </SectionHeading>
        <SectionCopy data-aos="fade-up" data-aos-delay="160">
          Meet the team at our Bakatue Street workspace in Accra. This is our
          primary office location for client meetings, planning, and collaboration.
        </SectionCopy>
        <DetailsList>
          <DetailItem data-aos="fade-up" data-aos-delay="200">
            <DetailLabel>Hours</DetailLabel>
            <DetailValue>Monday – Friday, 9:00am – 6:00pm GMT</DetailValue>
          </DetailItem>
          <DetailItem data-aos="fade-up" data-aos-delay="240">
            <DetailLabel>Client line</DetailLabel>
            <DetailValue>+233 25 611 1992</DetailValue>
          </DetailItem>
        </DetailsList>
        <ButtonGroup data-aos="fade-up" data-aos-delay="320">
          <Button
            props={{ bakground: colors.primary, hover: "#000", hoverColor: "white", color: "white" }}
            onClick={() => scrollIntoViewWithOffset("#contacts", 0)}
          >
            Contact us
            <HiOutlineArrowUpRight />
          </Button>
          <SecondaryLink
            href="https://www.google.com/maps/place/ced.+services/data=!4m2!3m1!1s0x0:0x3e667607e1993330?sa=X&ved=1t:2428&ictx=111"
            target="_blank"
            rel="noopener noreferrer"
            data-aos="fade-up"
            data-aos-delay="360"
          >
            Open in Google Maps
          </SecondaryLink>
        </ButtonGroup>
      </ContentColumn>
      <MapContainer data-aos="zoom-in">
        <iframe
          title="Cwin Technology Solutions office location"
          src="https://maps.google.com/maps?q=ced.%20services&t=&z=15&ie=UTF8&iwloc=&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          style={{ border: 0, width: "100%", height: "100%", borderRadius: 24 }}
        />
      </MapContainer>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  padding: 6% 5%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 40px;
  align-items: stretch;
  background: #f2f2f2;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    padding: 14% 5%;
  }
`;

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionTag = styled.span`
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 12px;
  color: ${colors.primary};
  opacity: 0.6;
`;

const SectionHeading = styled.h2`
  margin: 0;
  font-size: 32px;
  color: ${colors.primary};

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const SectionCopy = styled.p`
  margin: 0;
  font-size: 16px;
  color: #5a5a5a;
  line-height: 1.7;
`;

const DetailsList = styled.div`
  display: grid;
  gap: 16px;
`;

const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const DetailLabel = styled.span`
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(54, 56, 60, 0.6);
`;

const DetailValue = styled.span`
  font-size: 16px;
  color: ${colors.primary};
  line-height: 1.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

const SecondaryLink = styled.a`
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${colors.primary};
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;

  &:after {
    content: "";
    width: 100%;
    height: 1px;
    background: ${colors.primary};
    position: absolute;
    left: 0;
    bottom: -2px;
    transform-origin: left;
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover:after {
    transform: scaleX(1);
  }
`;

const MapContainer = styled.div`
  border-radius: 24px;
  overflow: hidden;
  /* box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1); */
  min-height: 360px;

  @media (max-width: 768px) {
    min-height: 300px;
  }
`;

export default LocationSection;
